export default __webpack_public_path__ + "static/media/Continental_Stand_Alone.c3649c06.svg";